var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import useScrollPosition from '@a0/docs-components/hooks/useScrollPosition';
import * as React from 'react';
import { Sticky } from 'react-sticky';
import { CATEGORIES } from '../../data';
import styles from './styles.module.styl';
var CATEGORIES_REVERSED = __spreadArray([], __read(CATEGORIES), false).reverse();
export var Sidebar = function (_a) {
    var categoryRefs = _a.categoryRefs;
    var _b = __read(React.useState(''), 2), activeLink = _b[0], setActiveLink = _b[1];
    // updates component on scroll
    useScrollPosition();
    var activeCategory = CATEGORIES_REVERSED.find(function (category) {
        var _a, _b;
        var ref = categoryRefs[category];
        var pos = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.y;
        return pos < 60;
    });
    React.useEffect(function () {
        setActiveLink(activeCategory);
    });
    return (React.createElement(Sticky, null, function (_a) {
        var style = _a.style;
        return (React.createElement("div", { style: style, className: styles.container },
            React.createElement("ul", { className: styles.listStyleNone },
                React.createElement("li", { className: styles.sectionitem },
                    React.createElement("a", { href: "#webapp", className: "".concat(styles.sectionLink, " ").concat(activeLink === 'webapp' && styles.activeLink) }, "Regular Web App")),
                React.createElement("li", { className: styles.sectionitem },
                    React.createElement("a", { href: "#spa", className: "".concat(styles.sectionLink, " ").concat(activeLink === 'spa' && styles.activeLink) }, "Single-Page App")),
                React.createElement("li", { className: styles.sectionitem },
                    React.createElement("a", { href: "#native", className: "".concat(styles.sectionLink, " ").concat(activeLink === 'native' && styles.activeLink) }, "Native/Mobile App")),
                React.createElement("li", { className: styles.sectionitem },
                    React.createElement("a", { href: "#backend", className: "".concat(styles.sectionLink, " ").concat(activeLink === 'backend' && styles.activeLink) }, "Backend/API")))));
    }));
};
